import type { ReactNode } from 'react'
import { LandingHeader } from '@/components/landing/LandingHeader'
import { GuestPageBackground } from '@/components/layout/GuestPageBackground'
import { PublicFooter } from '@/components/layout/PublicFooter'
import { usePublicLightTheme } from '@/hooks/usePublicLightTheme'

type PublicLegalLayoutProps = {
  children: ReactNode
}

export function PublicLegalLayout({ children }: PublicLegalLayoutProps) {
  usePublicLightTheme()

  return (
    <div className="relative min-h-screen text-foreground">
      <GuestPageBackground />
      <LandingHeader />
      <main className="relative">{children}</main>
      <PublicFooter />
    </div>
  )
}
